/* eslint-disable func-names */
import {
  COMMON_ACTION,
  FILTERS,
  GET_BLOGS_ACTION,
  GET_LATEST_NEWS_ACTION,
  ISSUE_ACTION,
  LOGIN_ACTION
} from "../constant";
import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import { get } from "lodash";
import { setLocalstorage, getLocalstorage, isDesktopView } from "../helper";

//import GlobalConfig from "../globalConfig";

export const toggleSidebar = () => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.TOGGLE_SIDEBAR
    });
  };
};

export const uploadFileAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.IMAGE_UPLOADING_START
    });
    return requestMethod(apiServices.uploadFile(params))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.IMAGE_UPLOADING_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.IMAGE_UPLOADING_FAILURE
        });
      });
  };
};

export const removeFileAction = (requestMethod = request, params) => {
  console.log("from common action");
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.DELETE_IMAGE_UPLOADING_SUCCESS
    });
    return {
      data: null,
      status: true,
      message: "File removed successfully"
    };

    // dispatch({
    //   type: COMMON_ACTION.DELETE_IMAGE_UPLOADING_START
    // });
    // return requestMethod(apiServices.removeFile(params))
    //   .then(response => {
    //     dispatch({
    //       type: COMMON_ACTION.DELETE_IMAGE_UPLOADING_SUCCESS
    //     });
    //     return {
    //       data: get(response, "data.data"),
    //       status: get(response, "data.status"),
    //       message: get(response, "data.message")
    //     };
    //   })
    //   .catch(err => {
    //     dispatch({
    //       type: COMMON_ACTION.DELETE_IMAGE_UPLOADING_FAILURE
    //     });
    //   });
  };
};

export const getIssueList = (requestMethod = request, params = {}) => {
  return requestMethod(apiServices.getissueListParams(params))
    .then(response => {
      return get(response, "data", {});
    })
    .catch(err => {
      return err;
    });
};

export const getIssueListForAgendaSelect = (
  requestMethod = request,
  params = {}
) => {
  return requestMethod(apiServices.getIssueListParamsForAgendaSelect(params))
    .then(response => {
      return get(response, "data", {});
    })
    .catch(err => {
      return err;
    });
};

export const getIssuesCategoryListAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.GET_ISSUES_CATEGORY_LIST_START
    });
    return requestMethod(apiServices.getIssuesCategoryList(params))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.GET_ISSUES_CATEGORY_LIST_SUCCESS,
          payload: get(response, "data.data", [])
        });
        return get(response, "data.data", []);
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.GET_ISSUES_CATEGORY_LIST_FAILURE
        });
      });
  };
};

export const getBucketListAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.GET_BUCKET_LIST_START
    });
    return requestMethod(apiServices.getBuckets(params))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.GET_BUCKET_LIST_SUCCESS,
          payload: get(response, "data.data", [])
        });
        return get(response, "data.data", []);
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.GET_BUCKET_LIST_FAILURE
        });
      });
  };
};

export const getMilestoneTableDataAction = (
  requestMethod = request,
  projectId,
  bucketId
) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.GET_MILESTONE_TABLE_START
    });
    return requestMethod(apiServices.getTables(projectId, bucketId))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.GET_MILESTONE_TABLE_SUCCESS,
          payload: get(response, "data.data", [])
        });
        return get(response, "data.data", []);
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.GET_MILESTONE_TABLE_FAILURE
        });
      });
  };
};

export const getMilestonesDataAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.GET_MILESTONE_LIST_START
    });
    return requestMethod(apiServices.getMilestones(params))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.GET_MILESTONE_LIST_SUCCESS,
          payload: get(response, "data.data", [])
        });
        return get(response, "data.data", []);
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.GET_MILESTONE_LIST_FAILURE
        });
      });
  };
};

export const getIssuesSubCategoryListAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.GET_ISSUES_SUB_CATEGORY_LIST_START
    });
    return requestMethod(apiServices.getIssuesSubCategoryList(params))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.GET_ISSUES_SUB_CATEGORY_LIST_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.GET_ISSUES_SUB_CATEGORY_LIST_FAILURE
        });
      });
  };
};

export const getForumListAction = (params, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.GET_FORUM_LIST_START
    });
    return requestMethod(apiServices.getForumList(params))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.GET_FORUM_LIST_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.GET_FORUM_LIST_FAILURE
        });
      });
  };
};

export const getProjectList = (requestMethod = request, params) => {
  return requestMethod(apiServices.getProjectList(params))
    .then(response => {
      const payload = response.data;
      const listOfProject = getLocalstorage("listOfProject") || null;
      if (listOfProject === null) {
        setLocalstorage("listOfProject", response.data.data.total || null);
      }
      return payload;
    })
    .catch(err => {
      return err;
    });
};

export const changePassword = (requestMethod = request, params) => {
  return requestMethod(apiServices.changePasswordParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("SignUp Failed", e.message);
    });
};

export const getOtpVerification = (requestMethod = request, params) => {
  return requestMethod(apiServices.getChangePasswordOTP(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Otp Failed", e.message);
    });
};

export const userSecurityKeyV2 = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.SECURITY_START
    });
    return requestMethod(apiServices._userSecurityKeyV2())
      .then(loginResp => {
        const payload = loginResp.data;
        dispatch({
          type: LOGIN_ACTION.SECURITY_SUCCESS,
          payload
        });
      })
      .catch(() => {
        dispatch({
          type: LOGIN_ACTION.SECURITY_FAILURE
        });
      });
  };
};

export const getSearchInputData = inputData => {
  return function(dispatch) {
    if (inputData.charAt(0) !== " ") {
      dispatch({
        type: COMMON_ACTION.SEARCH_INPUT_DATA,
        payload: inputData
      });
    }
  };
};

export const resetSearchInputData = () => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.RESET_SEARCH_INPUT_DATA
    });
  };
};

export const bannerMonitoredData = (requestMethod = request, params) => {
  return requestMethod(apiServices.bannerMonitoredDataAPI(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Banner Monitored Data Failed", e.message);
    });
};

export const getPermissionsAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.GET_PERMISSIONS_LIST_START
    });
    return requestMethod(apiServices.getPermissionsListing())
      .then(response => {
        const { data } = response;
        const payload = {
          data: get(data, "data", []),
          status: get(data, "status", false),
          message: get(data, "message", "")
        };
        dispatch({
          type: COMMON_ACTION.GET_PERMISSIONS_LIST_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.GET_PERMISSIONS_LIST_FAILURE
        });
      });
  };
};

export const stateWiseProjects = (requestMethod = request, params) => {
  return requestMethod(apiServices.stateWiseProjectsAPI(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("State Wise Data Failed", e.message);
    });
};

export const sectorWiseProjects = (requestMethod = request, params) => {
  return requestMethod(apiServices.sectorWiseProjectsAPI(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Sector Wise Data Failed", e.message);
    });
};

export const getLatestNews = (requestMethod = request, number) => {
  return function(dispatch) {
    dispatch({
      type: GET_LATEST_NEWS_ACTION.GET_LATEST_NEWS_START
    });
    return requestMethod(apiServices.getLatestNewsAPI(number))
      .then(resp => {
        dispatch({
          type: GET_LATEST_NEWS_ACTION.GET_LATEST_NEWS_SUCCESS,
          payload: resp.data.latestNews.list
        });
        return resp.data.latestNews.list;
      })
      .catch(() => {
        dispatch({
          type: GET_LATEST_NEWS_ACTION.GET_LATEST_NEWS_FAILURE
        });
      });
  };
};

export const getBlogs = (requestMethod = request, number) => {
  return function(dispatch) {
    dispatch({
      type: GET_BLOGS_ACTION.GET_BLOGS_START
    });
    return requestMethod(apiServices.getBlogsAPI(number))
      .then(resp => {
        dispatch({
          type: GET_BLOGS_ACTION.GET_BLOGS_SUCCESS,
          payload: resp.data.blogs.list
        });
        return resp.data.blogs.list;
      })
      .catch(() => {
        dispatch({
          type: GET_BLOGS_ACTION.GET_BLOGS_FAILURE
        });
      });
  };
};

export const latestNewsFeeds = (requestMethod = request, params) => {
  return requestMethod(apiServices.latestNewsFeedsAPI(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Latest News Feeds Failed", e.message);
    });
};

export const clearPermissionsList = () => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.CLEAR_PERMISSION
    });
  };
};

export const clearIssueList = () => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.CLEAR_ISSUE_DETAILS
    });
  };
};

export const getDistrictList = (requestMethod = request, id, isState) => {
  return requestMethod(apiServices.getStateDistrictAndDepartment(id, isState))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Error -", e.message);
    });
};

export const getDistrictAndDepartmentIssues = (
  requestMethod = request,
  id,
  isState,
  department
) => {
  return requestMethod(
    apiServices.getDistrictAndDepartmentIssues(id, isState, department)
  )
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Error -", e.message);
    });
};

export const getDivisionList = (requestMethod = request, id, isState) => {
  return requestMethod(apiServices.getDivisions(id, isState))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Error -", e.message);
    });
};

export const getSectorBasedOnSponsoringDepartment = (
  requestMethod = request,
  groupId
) => {
  return requestMethod(
    apiServices.getSectorBasedOnSponsoringDepartment(groupId)
  )
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Error -", e.message);
    });
};

export const downloadProjectListReportsAction = (
  requestMethod = request,
  data
) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.PROJECT_LIST_REPORT_DOWNLOAD_START
    });
    return requestMethod(apiServices.downloadReports(data))
      .then(resp => {
        const { data } = resp;
        if (get(data, "status")) {
          dispatch({
            type: COMMON_ACTION.PROJECT_LIST_REPORT_DOWNLOAD_SUCCESS,
            payload: get(data, "data.url")
          });
        } else {
          dispatch({
            type: COMMON_ACTION.PROJECT_LIST_REPORT_DOWNLOAD_SUCCESS,
            payload: null
          });
        }
        return resp;
      })
      .catch(() => {
        dispatch({
          type: COMMON_ACTION.PROJECT_LIST_REPORT_DOWNLOAD_FAILURE
        });
      });
  };
};

export const clearProjectListDownloadAction = function() {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.CLEAR_PROJECT_LIST_REPORT_DOWNLOAD
    });
  };
};

export const getProjectStakeHolderAction = (requestMethod = request, data) => {
  return requestMethod(apiServices.getProjectStokeHolderInfo(data)).then(
    resp => {
      return resp;
    }
  );
};

export const uploadFileTitleAction = (requestMethod = request, title) => {
  return requestMethod(apiServices.uploadFileTitle(title))
    .then(response => {
      return {
        data: get(response, "data.data"),
        status: get(response, "data.status"),
        message: get(response, "data.message")
      };
    })
    .catch(() => {});
};

export const windowResize = () => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.WINDOW_RESIZE,
      data: isDesktopView()
    });
  };
};

export const getPariveshDetails = (requestMethod = request, params = {}) => {
  return requestMethod(apiServices.getPariveshDetails(params))
    .then(response => {
      return get(response, "data", {});
    })
    .catch(err => {
      return err;
    });
};
export const proposalDetailValidation = (
  requestMethod = request,
  params = {}
) => {
  return requestMethod(apiServices.proposalDetailValidation(params))
    .then(response => {
      return get(response, "data", {});
    })
    .catch(err => {
      return err;
    });
};

export const uploadNewsLetterAction = (requestMethod = request, params) => {
  return function(dispatch) {
    dispatch({
      type: COMMON_ACTION.IMAGE_UPLOADING_START
    });
    dispatch({
      type: COMMON_ACTION.UPLOADING_START
    });
    return requestMethod(apiServices.uploadNewsLetter(params))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.IMAGE_UPLOADING_SUCCESS
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.IMAGE_UPLOADING_FAILURE
        });
      });
  };
};

export const uploadStatusAction = (requestMethod = request, params) => {
  return function(dispatch) {
    // dispatch({
    //   type: COMMON_ACTION.UPLOADING_START
    // });
    return requestMethod(apiServices.getStatusUpload(params))
      .then(response => {
        dispatch({
          type: COMMON_ACTION.UPLOADING_SUCCESS,
          payload: response.data.data.percentTransferred
        });
        return {
          data: get(response, "data.data"),
          status: get(response, "data.status"),
          message: get(response, "data.message")
        };
      })
      .catch(err => {
        dispatch({
          type: COMMON_ACTION.UPLOADING_FAILURE
        });
      });
  };
};
